import { render } from "./Mic.vue?vue&type=template&id=12b15153&scoped=true"
import script from "./Mic.vue?vue&type=script&lang=js"
export * from "./Mic.vue?vue&type=script&lang=js"

import "./Mic.vue?vue&type=style&index=0&id=12b15153&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\_TESTS\\poc-microphone\\poc-record\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b15153"]])

export default __exports__